import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {FormComponent} from '@ngx-ivengi/crud';
import {RoomService} from './room.service';
import {Room} from './room.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-room-form',
  templateUrl: './room-form.component.html'
})
export class RoomFormComponent extends FormComponent implements OnInit {

  public room: Room = new Room();
  public formTitle: string;
  public stateIdParam: string = 'roomId';

  constructor(
    private roomService: RoomService,
    protected router: UIRouter,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.roomService.setRoutePrefix(`building/${this.router.stateService.params.buildingId}/floor/${this.router.stateService.params.floorId}`);

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('room.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.translate.get('room.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.roomService.get(this.router.stateService.params[this.stateIdParam]).subscribe((room: Room) => {
          this.room = room;
        });
      } break;
    }
  }

  public save(): void {

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.roomService.add(this.room).subscribe((result) => {
          this.router.stateService.go('building.edit.floor.edit', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.roomService.update(this.room).subscribe((result) => {
          this.router.stateService.go('building.edit.floor.edit', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room-form.component.ts